import { sqliteTable, text, real } from "drizzle-orm/sqlite-core";

// ============================================================================
// rental_settings — ตั้งค่าระบบเช่ารถ (per company)
// ============================================================================
export const rentalSettings = sqliteTable("car_rental_rental_settings", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull().unique(),
  workflowType: text("workflow_type", {
    enum: ["corporate", "standard"],
  }).notNull().default("standard"),
  defaultCalculationMethod: text("default_calculation_method", {
    enum: ["24_hour_cycle", "daily"],
  }).notNull().default("24_hour_cycle"),
  defaultTaxType: text("default_tax_type", {
    enum: ["no_tax", "tax_inclusive", "tax_exclusive"],
  }).notNull().default("no_tax"),
  defaultTaxRate: real("default_tax_rate").notNull().default(0),
  defaultTaxTemplateId: text("default_tax_template_id"), // FK → tax_templates
  defaultDepositAmount: text("default_deposit_amount"), // stored as text, parsed as number
  defaultDailyCutoffTime: text("default_daily_cutoff_time"),        // เวลา cutoff (เฉพาะโหมดรายวัน)
  defaultDailyRate: real("default_daily_rate"),                    // ค่าเช่ารายวันเริ่มต้น
  defaultHourlyRate: real("default_hourly_rate"),                  // ค่าเช่ารายชั่วโมงเริ่มต้น
  defaultSecurityDeposit: real("default_security_deposit"),         // เงินประกันเริ่มต้น
  defaultLateFeePerHour: real("default_late_fee_per_hour"),        // ค่าปรับคืนช้า/ชม.
  defaultGracePeriodHours: real("default_grace_period_hours"),     // ระยะผ่อนปรน (ชม.)
  defaultExtraDayThresholdHours: real("default_extra_day_threshold_hours"), // ชม.เกินนับเป็นวันใหม่
  defaultDriverRatePerDay: real("default_driver_rate_per_day"),    // ค่าคนขับ/วัน

  // ============================================================================
  // NOTE: ไม่มี account fields — จัดการผ่าน:
  //   - Items master data (CAR-RENTAL-SERVICE, CAR-RENTAL-DRIVER, CAR-RENTAL-DEPOSIT, CAR-RENTAL-LATE-FEE)
  //   - Payment Methods (เงินสด, โอนเงิน, etc.)
  //   - Company Settings (default AR, AP, Cash)
  // ============================================================================

  // Timestamps & Audit (settings — no delete fields)
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
});

export type RentalSettings = typeof rentalSettings.$inferSelect;
export type NewRentalSettings = typeof rentalSettings.$inferInsert;
